import React from "react";
import InputBox from 'components/reusable/InputBox';
import CookieManager from "utilities/js/localstorage/CookieManager";
import Constants from "utilities/js/Constants";
import {login, registerUser, sendVerifyEmail} from "utilities/js/callouts/CalloutFactory";
import './LoginForm.css';
import { navigateToForgotPasswordPage } from "utilities/js/NavigationHelper";
import Toast from "components/reusable/Toast";
import { showInfoToast } from "utilities/js/ToastHelper";
import { isValidEmail } from "utilities/js/callouts/Sanitizer";
import { isValidUsername } from "utilities/js/callouts/Sanitizer";
import { NavigatorWrapper } from "components/reusable/NavigatorWrapper";
import { navigateToLandingPage } from "utilities/js/NavigationHelper";
import { setRecentViewBackets } from "utilities/js/localstorage/StorageHelper_ViewBrackets";
import { setRecentCreateBackets } from "utilities/js/localstorage/StorageHelper_CreateBrackets";

const loadingIcon = Constants.ICON_LOADING;

let cookieManager = new CookieManager();

class LoginForm extends React.Component {

    constructor(props){
        super(props);
        
        this.registerInputContainerRef = React.createRef();
        this.loginInputContainerRef = React.createRef();
        this.formContainerRef = React.createRef();

        this.state = {
            loginEmail: '',
            loginPassword: '',
            registerFirstName: '',
            registerLastName: '',
            registerEmail: '',
            registerPassword: '',
            registerVerifyPassword: '',
            registerUsername: '',

            displayLoginScreen: true,
            errorDisplay: '',

            toastMessages: []
        };
        
        this.login = this.login.bind(this);
        this.registerUser = this.registerUser.bind(this);  
        this.closePanel = this.closePanel.bind(this);  
        this.setLoginEmail = this.setLoginEmail.bind(this);  
        this.setLoginPassword = this.setLoginPassword.bind(this);  
        this.setRegisterEmail = this.setRegisterEmail.bind(this);  
        this.setRegisterPassword = this.setRegisterPassword.bind(this);
        this.setRegisterVerifyPassword = this.setRegisterVerifyPassword.bind(this);  
        this.setRegisterFirstName = this.setRegisterFirstName.bind(this);  
        this.setRegisterLastName = this.setRegisterLastName.bind(this);  
        this.setRegisterUsername = this.setRegisterUsername.bind(this);    
        this.openLoginScreen = this.openLoginScreen.bind(this);  
        this.openRegisterScreen = this.openRegisterScreen.bind(this); 
        this.getLoginScreen = this.getLoginScreen.bind(this);      
        this.sendEmailVerification = this.sendEmailVerification.bind(this);
        this.allowSubmitOnEnter = this.allowSubmitOnEnter.bind(this);

    }

    componentDidMount(){
        this.allowSubmitOnEnter();
    }
    /*********************** Login and Register Logic **************************/
    login(){
        if(this.areLoginInputsValid()){
            this.setState({"isLoading": true});

            login({email: this.state.loginEmail, password: this.state.loginPassword}).then(response => {
                //set cookie with jwt key
                //TODO: check if this jwt token is always the same
                cookieManager.setValueWithExpiration(Constants.COOKIE_USER_KEY, response.token, Constants.COOKIE_HOURS_EXPIRATION);
                cookieManager.setValueWithExpiration(Constants.COOKIE_USERNAME_KEY, response.username, Constants.COOKIE_HOURS_EXPIRATION);
                cookieManager.setValueWithExpiration(Constants.COOKIE_USER_EMAIL_KEY, response.email, Constants.COOKIE_HOURS_EXPIRATION);
                cookieManager.setValueWithExpiration(Constants.COOKIE_USER_ID, response._id, Constants.COOKIE_HOURS_EXPIRATION);

                setRecentViewBackets(null);
                setRecentCreateBackets(null);
                
                if(this.props.navigateHomeOnLogin){
                    navigateToLandingPage({routerNav: this.props.navigate});
                }else{
                    window.location.reload();
                }
                //this.props.loginCallback(this.state.poll);
                this.setState({errorDisplay: ''});

            }).catch((error) => {
                let errorDisplay = 'Something went wrong.';
                if(error.code){
                    errorDisplay = error.message;
                }
                console.log(error);
                this.setState({"isLoading": false, errorDisplay: errorDisplay})
            });
        }

    }

    async registerUser(){
        let isValid = this.areRegisterInputsValid();
        let errorDisplay;
        if(isValid){
            this.setState({"isLoading": true});
            try{
                let response = await registerUser({username: this.state.registerUsername, firstName: this.state.registerFirstName, lastName: this.state.registerLastName, email: this.state.registerEmail, password: this.state.registerPassword});
            
                //set cookie with jwt key
                cookieManager.setValueWithExpiration(Constants.COOKIE_USER_KEY, response.token, Constants.COOKIE_HOURS_EXPIRATION);
                cookieManager.setValueWithExpiration(Constants.COOKIE_USERNAME_KEY, response.username, Constants.COOKIE_HOURS_EXPIRATION);
                cookieManager.setValueWithExpiration(Constants.COOKIE_USER_EMAIL_KEY, response.email, Constants.COOKIE_HOURS_EXPIRATION);
                //TODO: Not essential, but consider encrypting this value and decrypting when verifying user in addition to token
                cookieManager.setValueWithExpiration(Constants.COOKIE_USER_ID, response._id, Constants.COOKIE_HOURS_EXPIRATION);

                setRecentViewBackets(null);
                setRecentCreateBackets(null);

                this.setState({errorDisplay: ''});
                await this.sendEmailVerification();
                if(this.props.navigateHomeOnLogin){
                    navigateToLandingPage({routerNav: this.props.navigate});
                }else{
                    window.location.reload();
                }
                this.closePanel();

            }catch(error){
                errorDisplay = 'Something went wrong.';
                if(error.code){
                    errorDisplay = error.message;
                }
                console.log(error);
                this.setState({"isLoading": false, errorDisplay: errorDisplay});
                // this.registerInputContainerRef.current.scrollTop = 0;
            };
        }

        if(errorDisplay){
            this.setState({errorDisplay: errorDisplay});
        }

    }

    areRegisterInputsValid(){
        let errorDisplay;
        if(!this.state.registerUsername || !this.state.registerEmail || !this.state.registerPassword || !this.state.registerFirstName || !this.state.registerLastName){
            errorDisplay = 'All fields must be populated';
        }else if(this.state.registerPassword !== this.state.registerVerifyPassword){
            errorDisplay = 'Passwords do not match';
        }else if(!isValidEmail(this.state.registerEmail)){
            errorDisplay = 'Email Address must be legitimate';
        }else if(!isValidUsername(this.state.registerUsername)){
            errorDisplay = 'Username must be at least 6 characters and contain no special characters'
        }

        if(errorDisplay){
            this.setState({errorDisplay: errorDisplay});
            this.registerInputContainerRef.current.scrollTop = 0;
            return false;
        }

        return true;
    }

    areLoginInputsValid(){
        let errorDisplay;
        if(!this.state.loginEmail || !this.state.loginPassword){
            errorDisplay = 'must populate all fields';
        }else if(!isValidEmail(this.state.loginEmail) && !isValidUsername(this.state.loginEmail)){
            errorDisplay = 'Email Address must be legitimate';
        }
        if(errorDisplay){
            this.setState({errorDisplay: errorDisplay});
            this.loginInputContainerRef.current.scrollTop = 0;
            return false;
        }

        return true;
    }
    
    sendEmailVerification = async () => {
        try{
            let response = await sendVerifyEmail();
            console.log('email sent successfully');
            showInfoToast(this, 'An email has been sent for you to verify your email address');
        }catch(error){
            console.log('cound not send email');
            showInfoToast(this, 'There was an issue sending an email to your email address');
            console.log(error);
        }finally{

        };
    }

    allowSubmitOnEnter(){
        let container = this.formContainerRef.current.addEventListener("keypress", function(event) {
            if (event.key === "Enter") {
                let loginButton = event.currentTarget.querySelector("#login-button");
                let registerButton = event.currentTarget.querySelector("#register-button");

                // Cancel the default action, if needed
                event.preventDefault();
                if(loginButton){
                    loginButton.click();
                }else if(registerButton){
                    registerButton.click();
                }
            }
        });
    }

    /******************************* Input Setters  ************************************/
    setLoginEmail(event){
        this.setState({loginEmail: event.target.value});
    }

    setLoginPassword(event){
        this.setState({loginPassword: event.target.value});
    }

    setRegisterEmail(event){
        this.setState({registerEmail: event.target.value});
    }

    setRegisterFirstName(event){
        this.setState({registerFirstName: event.target.value});
    }

    setRegisterLastName(event){
        this.setState({registerLastName: event.target.value});
    }

    setRegisterPassword(event){
        this.setState({registerPassword: event.target.value});
    }
    setRegisterVerifyPassword(event){
        this.setState({registerVerifyPassword: event.target.value});
    }

    setRegisterUsername(event){
        this.setState({registerUsername: event.target.value});
    }

    /*********************** Screen flow controls ***********************/

    openLoginScreen(){
        this.setState({displayLoginScreen: true, errorDisplay: ''});
    }

    openRegisterScreen(){
        this.setState({displayLoginScreen: false, errorDisplay: ''});
    }

    closePanel(){
        this.props.closePanel();
    }



    /*********************** UI Render Helpers ***********************/
    loadingScreen(){
        if(this.state.isLoading){
            return (<div className="loading-icon-container"><img src={loadingIcon} alt="loading"></img></div>)
        }
        return;
    }

    getLoginScreen(){
        let errorMessages = <></>
        if(this.state.errorDisplay){
            errorMessages = <div className="error-messages">{this.state.errorDisplay}</div>
        }
        let screenForm = <></>
        if(!this.state.isLoading){
            if(this.state.displayLoginScreen){
                screenForm = (
                    <>
                        <div className="login-input-container" ref={this.loginInputContainerRef}>
                            <div className="login-form-header-container">
                                <div className="login-form-header">Welcome Back</div>
                                <div className="login-form-sub-header"></div>
                                {errorMessages}
                            </div>
                            <div className="input-container">
                                {/* <div className="login-form-label-text">Username or Email</div> */}
                                <InputBox uniqueKey="email" key="email" name='loginEmail' placeholder='username or email' class='login-styled-input' value={this.state.loginEmail} valueChangedCallback={this.setLoginEmail}></InputBox>
                            </div>
                            <div className="input-container">
                                {/* <div className="login-form-label-text">Password</div> */}
                                <InputBox uniqueKey="password" key="password" name='loginPassword' type="password" placeholder='password' class='login-styled-input' value={this.state.loginPassword} valueChangedCallback={this.setLoginPassword}></InputBox>
                            </div>
                            <div className="login-button-container">
                                <button id="login-button" label='login-button' className='nav-button' onClick={this.login}>Login</button>
                            </div>
                            <div className="bottom-screen-login-message">
                                <button className="login-toggle-button" onClick={() => {navigateToForgotPasswordPage({routerNav: this.props.navigate})}}>Forgot Password?</button>
                            </div>
                        </div>
                        <div className="spacer"></div>
                        <div className="bottom-screen-login-message">
                            Not signed up? <button className="login-toggle-button" onClick={this.openRegisterScreen}>Register</button>
                        </div>
                    </>
                );
            }else{
                screenForm = (
                    <>
                        <div className="register-input-container" ref={this.registerInputContainerRef}>
                            <div className="login-form-header-container">
                                <div className="login-form-header">Sign Up</div>
                                <div className="login-form-sub-header">Register to start publishing brackets</div>
                                {errorMessages}
                            </div>
                            <div className="side-by-side-input">
                                <div className="input-container input-stretch">
                                    {/* <div className="login-form-label-text">First Name</div> */}
                                    <InputBox uniqueKey="firstname" key="firstname" name='registerFirstName' type="text" placeholder='First Name' class='login-styled-input' value={this.state.registerFirstName} valueChangedCallback={this.setRegisterFirstName}></InputBox>
                                </div>
                                <div className="input-container input-stretch">
                                    {/* <div className="login-form-label-text">Last Name</div> */}
                                    <InputBox  uniqueKey="lastname" key="lastname" name='registerLastName' type="text" placeholder='Last Name' class='login-styled-input' value={this.state.registerLastName} valueChangedCallback={this.setRegisterLastName}></InputBox>
                                </div>
                            </div>
                            <div className="input-container">
                                {/* <div className="login-form-label-text">Email</div> */}
                                <InputBox uniqueKey="register-email" key="register-email" name='registerEmail' type="text" placeholder='Email' class='login-styled-input' value={this.state.registerEmail} valueChangedCallback={this.setRegisterEmail}></InputBox>
                            </div>
                            <div className="input-container">
                                <div className="login-form-label-text">Choose a unique Username</div>
                                <InputBox uniqueKey="username" key="username" name='registerUsername' type="text" placeholder='Username' class='login-styled-input' value={this.state.registerUsername} valueChangedCallback={this.setRegisterUsername}></InputBox>
                            </div>
                            <div className="side-by-side-input">
                                <div className="input-container input-stretch">
                                    {/* <div className="login-form-label-text">Password</div> */}
                                    <InputBox uniqueKey="register-password" key="register-password" name='registerPassword' type="password" placeholder='Password' class='login-styled-input' value={this.state.registerPassword} valueChangedCallback={this.setRegisterPassword}></InputBox>
                                </div>
                                <div className="input-container input-stretch">
                                    {/* <div className="login-form-label-text">Verify Password</div> */}
                                    <InputBox uniqueKey="register-verify-password" key="register-verify-password" name='registerVerifyPassword' type="password" placeholder='Verify Password' class='login-styled-input' value={this.state.registerVerifyPassword} valueChangedCallback={this.setRegisterVerifyPassword}></InputBox>
                                </div>
                            </div>
                            <div className="login-button-container">
                                <button id="register-button" label='register-user' className='nav-button' onClick={this.registerUser}>Register</button>
                            </div>
                        </div>
                        <div className="spacer"></div>
                        <div className="bottom-screen-login-message">
                            Already have an account? <button className="login-toggle-button" onClick={this.openLoginScreen}>Login</button>
                        </div>
                    </>
                );
            }
            return ( 
                // <div className="centering-container">
                    
                    <div ref={this.formContainerRef} className="login-screen-content-container">
                        <div className="spacer"></div>
                        {screenForm}
                    </div>
                // </div>
            )
        }
    }

    render(){

        return (
            <>
                {this.loadingScreen()}
                {this.getLoginScreen()}
                <Toast toastList={this.state.toastMessages} position="top-left" autoDelete="true" autoDeleteTime="5000"/>                
            </>
        );
    }
}

export default NavigatorWrapper(LoginForm);
